module.exports = __webpack_public_path__ + "static/media/aiNew.950713a2.svg";